import * as SelectPrimitive from '@radix-ui/react-select';
import { Check, ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';

import { ClassNames } from '@/shared/classNames';

type SelectOption = {
  label: string;
  value: string;
};

type SelectProperties = {
  label: string;
  onValueChange: (value: string) => void;
  options: SelectOption[];
  value: string;
};

export const Select = ({ label, onValueChange, options, value }: SelectProperties) => (
  <label className="text-muted grid gap-1.5 text-xs font-semibold">
    {label}
    <SelectPrimitive.Root onValueChange={onValueChange} value={value}>
      <SelectPrimitive.Trigger className="border-line bg-raised text-ink hover:border-line-strong focus:border-accent inline-flex min-h-10 min-w-32 items-center justify-between gap-2 rounded-md border px-3 text-sm transition-colors">
        <SelectPrimitive.Value />
        <SelectPrimitive.Icon>
          <ChevronDown aria-hidden="true" className="text-muted size-4" />
        </SelectPrimitive.Icon>
      </SelectPrimitive.Trigger>
      <SelectPrimitive.Portal>
        <SelectPrimitive.Content
          className="border-line bg-raised shadow-raised z-50 min-w-36 overflow-hidden rounded-lg border"
          position="popper"
          sideOffset={6}
        >
          <SelectPrimitive.Viewport className="p-1">
            {options.map((option) => (
              <SelectPrimitive.Item
                className={ClassNames(
                  'text-ink relative flex min-h-9 cursor-default items-center rounded-md px-8 text-sm outline-none select-none',
                  'data-[highlighted]:bg-selection data-[highlighted]:text-ink',
                )}
                key={option.value}
                value={option.value}
              >
                <span className="absolute left-2 flex size-4 items-center justify-center">
                  <SelectPrimitive.ItemIndicator>
                    <Check aria-hidden="true" className="size-4" />
                  </SelectPrimitive.ItemIndicator>
                </span>
                <SelectPrimitive.ItemText>{option.label}</SelectPrimitive.ItemText>
              </SelectPrimitive.Item>
            ))}
          </SelectPrimitive.Viewport>
        </SelectPrimitive.Content>
      </SelectPrimitive.Portal>
    </SelectPrimitive.Root>
  </label>
);

export const SelectGroup = ({ children }: { children: ReactNode }) => <div className="flex flex-wrap items-end gap-3">{children}</div>;
